import React from 'react';
import dateformat from 'dateformat';

import IconSelector from '@ibibo/icon-selector';

import * as S from './CancellationHeader.styles';
import * as SS from '../../../RescheduleFlow/RescheduleLeftBlock/HeaderReschedule/HeaderReschedule.styles';

const isDateValid = (d) => {
  return (d instanceof Date && !isNaN(d));
}

const CancellationHeader = ({headerText='Cancel Hotel', activeTab, showTabs=true, updateActiveTab, hotelDetails}) => {
  const {hotelName, checkin, checkout} = hotelDetails;
  return(
    <S.HeaderCanelMainWrap>
      <S.HeaderCancelOuterWrap>
        <S.HeaderCancelImgWrap>
          <IconSelector iconKey="cancelheader" />
        </S.HeaderCancelImgWrap>
        <S.HeaderCancelInfoWrap>
          <S.HeaderCancelText>{headerText}</S.HeaderCancelText>
          <S.HeaderCancelInfoInnerWrap>
            <S.HeaderCancelHtlInfo>{hotelName}</S.HeaderCancelHtlInfo>
            <S.HeaderCancelHtlDateInfoWrap>
              <S.HeaderCacnelHtlDateImg>
                <IconSelector iconKey="calendergrey" />
              </S.HeaderCacnelHtlDateImg>
              <S.HeaderCancelDateText>{isDateValid(checkin) ? dateformat(checkin, 'dd mmm') : ''} - {isDateValid(checkout) ? dateformat(checkout, 'dd mmm') : ''}</S.HeaderCancelDateText>
            </S.HeaderCancelHtlDateInfoWrap>
          </S.HeaderCancelInfoInnerWrap>
        </S.HeaderCancelInfoWrap>
      </S.HeaderCancelOuterWrap>
      {(showTabs && <S.HeaderStepBlock>
        <SS.HeaderStepInnerBlock>
          <S.HeaderStepFirstBlock isActive={activeTab === 'refund'} onClick={() => {
            if (activeTab !== 'refund') {
              updateActiveTab('refund');
            }
          }}>
            <S.HeaderStepWrap isActive={activeTab === 'refund'}>1</S.HeaderStepWrap>
            <S.HeaderStepText isActive={activeTab === 'refund'}>View Refund</S.HeaderStepText>
          </S.HeaderStepFirstBlock>
          <IconSelector iconKey={activeTab === 'refund' ? 'arrowactive' : 'arrow'} props={{margin:'0 0 0 -1px'}}/>
        </SS.HeaderStepInnerBlock>
        
        <SS.HeaderStepInnerBlock>
          <S.HeaderStepFirstBlock isActive={activeTab === 'confirm'} onClick={() => {
            if (activeTab !== 'confirm') {
              updateActiveTab('confirm');
            }
          }}>
            <S.HeaderStepWrap isActive={activeTab === 'confirm'}>2</S.HeaderStepWrap>
            <S.HeaderStepText isActive={activeTab === 'confirm'}>Confirm Cancellation</S.HeaderStepText>
          </S.HeaderStepFirstBlock>
          <IconSelector iconKey={activeTab === 'confirm' ? 'arrowactive' : 'arrow'} props={{margin:'0 0 0 -1px'}}/>
        </SS.HeaderStepInnerBlock>
      </S.HeaderStepBlock>) || null}
    </S.HeaderCanelMainWrap>
  );
}

export default CancellationHeader;